import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetNewsletterEditions as GetNewsletterEditionsQuery,
    GetNewsletterEditionsVariables as GetNewsletterEditionsQueryVariables,
    EditionStubFragment as EditionStub,
} from 'nutshell-graphql-types';

import {getNewsletterEditionListQueryVariables} from '../helpers';

import GET_EDITIONS from './graphql/queries/get-editions.graphql';

type Props = {
    newsletterId: string;
    isArchived?: boolean;
    children: (arg1: {
        editions: EditionStub[];
        error: string | null | undefined;
        isLoading: boolean;
    }) => React.ReactElement;
};

export function EditionListQuery(props: Props) {
    const variables = getNewsletterEditionListQueryVariables(props.newsletterId, props.isArchived);

    const {
        data,
        loading: isLoading,
        error,
    } = useQuery<GetNewsletterEditionsQuery, GetNewsletterEditionsQueryVariables>(GET_EDITIONS, {
        variables: variables,
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    const editionsData = data && data.newsletter ? data.newsletter.editions : null;

    const editions = editionsData
        ? editionsData.edges.map((campaign) => {
              return campaign.node;
          })
        : [];

    return props.children({
        editions,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
    });
}
